import Checkbox from "@/components/checkbox"

const AptSelectTable = ({ list = [], selectedCodes = [], onToggle }) => {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200">
      <div
        className="
          grid grid-cols-[180px_1fr_60px]
          items-center
          bg-gray-50
          px-4 pt-3.5 pb-2
          text-xs font-semibold text-gray-500
        "
      >
        <p>아파트 코드</p>
        <p>아파트 명</p>
        <div className="text-center">선택</div>
      </div>

      <div className="max-h-60 overflow-y-auto">
        {list.map((apt) => {
          const isSelected = selectedCodes.includes(apt.kapt_code)

          return (
            <div
              key={apt.kapt_code}
              onClick={() => onToggle?.(apt.kapt_code)}
              className={`
                grid min-h-12 cursor-pointer
                grid-cols-[180px_1fr_60px]
                items-center border-t border-t-gray-200 px-4 pt-0.5
                text-sm transition-colors
                ${isSelected ? "bg-blue-50" : "hover:bg-gray-50"}
              `}
            >
              <div
                className={`
                  truncate font-mono text-xs
                  ${isSelected ? "text-toicos-navy" : "text-gray-600"}
                `}
                title={apt.kapt_code}
              >
                {apt.kapt_code}
              </div>

              <div
                className={`
                  truncate pr-4
                  ${isSelected ? "font-medium text-gray-900" : "text-gray-700"}
                `}
                title={apt.apt_name}
              >
                {apt.apt_name}
              </div>

              <div className="flex justify-center">
                <Checkbox
                  checked={isSelected}
                  onChange={(e) => {
                    e.stopPropagation()
                    onToggle?.(apt.kapt_code)
                  }}
                />
              </div>
            </div>
          )
        })}

        {!list.length && (
          <div className="flex h-64 items-center justify-center text-sm text-gray-400">
            검색 결과가 없습니다.
          </div>
        )}
      </div>
    </div>
  )
}

export default AptSelectTable
